import React from "react";
import "../../css/new-round.css";
import { Dropdown } from "primereact/dropdown";

export function PuttingGamesDropdown({ selectedGame, setSelectedGame, games }) {




    return (
        <div>
            <Dropdown id="gamesdropdown"
                color="primary"
                value={selectedGame}
                onChange={(event) => {
                    setSelectedGame(event.target.value)
                }}
                options={games.map(group => ({
                    ...group,
                    drills: group.drills.sort((a, b) => a.name.localeCompare(b.name))
                }))}
                filter
                filterPlaceholder="Search game"
                optionLabel="name"
                placeholder="Select a Game"
                className="w-full md:w-14rem"
                optionGroupLabel="group"
                optionGroupChildren="drills" />
        </div>
    )
}
